/* Packages */
import React, {forwardRef, useEffect, useState} from 'react';
import Form from 'react-bootstrap/Form';
import { useFormContext } from 'react-hook-form';
import DatePicker from 'react-datepicker';
import { format } from 'date-fns';
import { trans, getDatePickerLocale } from 'js/utilities';

/* Hooks */
import useValidation from 'conversie-flow-bundle/assets/js/components/flow/hooks/useValidation';

/* Components */
import ConversionComponentQuickDate from "../components/ConversionComponentQuickDate";

const dateDisplayFormat = "dd-MM-yyyy"
const dateBackendFormat = "yyyy-MM-dd"

export default function ConversionFieldDatePicker(props) {
    const { colClassName, field, path, id, updateValue } = props;
    const { type, label, required, disabled, placeholder = null, value, name, minDate, maxDate, disabledDays = [] } = field;
    const [numberOfDays, setNumberOfDays] = useState(() => {
        if (window.innerWidth > 1599) return 7;
        if (window.innerWidth > 1440) return 6;
        if (window.innerWidth > 1260) return 5;
        return 4;
    })

    const updateNumberOfDays = () => {
        setNumberOfDays(window.innerWidth > 1599 ? 7 : window.innerWidth > 1440 ? 6 : window.innerWidth > 1260 ? 5 : 4);
    };

    window.addEventListener('resize', updateNumberOfDays);

    const form = useFormContext();
    const {
        setValue = () => { },
        trigger = () => { },
    } = form || {};

    const { error } = useValidation({ path, ...field, ...form });


    useEffect(() => {
        setValue(path, value);
        }, [value]);

    const resolveDateValue = (value) => {
        if (value && !(value instanceof Date)) {
            return new Date(value);
        }

        return value;
    };

    const filterDate = (date) => {
        const day = date?.getDay();
        return !disabledDays?.includes(day);
    }

    const ShowMoreToggle = forwardRef(({ value, onClick }, ref) => (
        <p className="btn btn-outline-base btn-sm font-weight-bold text--sm mt-4 cursor-pointer" onClick={onClick} ref={ref} data-value={value}>
            {trans(`webstores_conversion_flow.show_more`)}
        </p>
    ));
    ShowMoreToggle.displayName = "ShowMoreToggle";

    return (
        <div className={`${colClassName}`}>
            <Form.Group controlId={id} className={`form-group--flow form-group--flow-field-${type} form-group--flow-${name}`}>
                {label && (
                    <Form.Label dangerouslySetInnerHTML={{ __html: label }} />
                    )}
                <ConversionComponentQuickDate
                    numberOfDays={numberOfDays}
                    updateValue={updateValue}
                    dateBackendFormat={dateBackendFormat}
                    value={value}
                />
                <DatePicker
                    className={`form-control ${error ? 'is-error' : ''}`}
                    selected={resolveDateValue(value)}
                    minDate={minDate ? new Date(minDate) : null}
                    maxDate={maxDate ? new Date(maxDate) : null}
                    placeholderText={placeholder}
                    id={id}
                    name={id}
                    dateFormat={dateDisplayFormat}
                    {...{
                    type,
                        required,
                        disabled,
                    }}
                    filterDate={filterDate}
                    customInput={<ShowMoreToggle />}
                    popperPlacement="bottom-start"
                    locale={getDatePickerLocale()}
                    onChange={(date) => {
                        updateValue(format(date, dateBackendFormat), () => {
                            trigger(path);
                        });
                    }}
                />

                {error && (
                    <Form.Control.Feedback type="invalid">
                        {error}
                    </Form.Control.Feedback>
                    )}
            </Form.Group>
        </div>
        );
}
